import { Component, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { JoinSessionVM } from '../../models/JoinSessionVM';
import { FormBuilder } from '@angular/forms';
import { CommsService } from '../../../services/comms.service';
import { JoinSessionResponseVM } from '../../models/JoinSessionResponseVM';
import { SessionType } from '../../models/SessionType';
import { SessionStatus } from '../../models/SessionStatus';

@Component({
  selector: 'step-3-speakers',
  templateUrl: './step-3-speakers.component.html'
})
export class Step3SpeakersComponent implements AfterViewInit {

  @Output() OnChanged: EventEmitter<number> = new EventEmitter();

  ngAfterViewInit(): void {
  }

  setDeviceSetupStage2() {
    this.OnChanged.emit(2);
  }

  setDeviceSetupStage4() {
    this.OnChanged.emit(4);
  }

}
